declare let accounting: accounting.Static;

import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplicatiom from '@/Management/RADApplication';
import ResourceManager from '@/Management/ResourceManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import CurrencyHelper from '@/Utility/CurrencyHelper';

/**
 * Das ViewModel für CurrencyLabel
 */
export default class CurrencyLabelViewModel extends ControlViewModel {
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Der Wert
     */
    public value: KnockoutObservable<string>;

    /**
     * Die Id der Währung
     */
    public currencyId: KnockoutObservable<string>;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die CurrencyLabel
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, null);
        this.currencyId = this.observableOrDefault(params.currencyId, null);
        this.label = new this.LabelViewModel({
            locator: this.locator,
            caption: this.defineComputed(() => {
                return CurrencyHelper.toCurrencyString(this.value(), this.currencyId());
            })
        });
    }
}

ComponentManager.setViewModel('CurrencyLabelViewModel', CurrencyLabelViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');